export enum HotkeyModifierKeyKind {
  AltKey = 1,
  CtrlKey = 2,
  ShiftKey = 4,
  MetaKey = 8
}